<ng-container #container appViewFormGenerator></ng-container>
